import React, { Component } from 'react'

import github from "../images/github.png"
import githubAccent from "../images/github_accent.png"


const Footer = () => (
    <div className="footer">
        <center><span id="copyright"> &copy; twaddle 2020</span></center>
        <center><span id="socialIcons"><a href="https://github.com/twaddle-dev"><img src={ github } /></a></span></center>
    </div>
)

export default Footer